"use client";

import React, { useContext } from "react";
import { TabContext } from "./TabContext";

/**
 * Tab.Container - Provides shared state for Nav + Tab.Content/Pane.
 */
function TabContainer({
  children,
  activeKey,
  defaultActiveKey,
  onSelect,
  ...props
}) {
  return (
    <TabContext.Provider
      value={{ activeKey: activeKey ?? defaultActiveKey ?? null, onSelect }}
    >
      <div {...props}>{children}</div>
    </TabContext.Provider>
  );
}

/**
 * Tab.Content - Wrapper for Tab.Pane elements.
 */
function TabContent({ children, className = "", ...props }) {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}

/**
 * Tab.Pane - Shows content when its eventKey matches the active key.
 */
function TabPane({ children, eventKey, className = "", ...props }) {
  const { activeKey } = useContext(TabContext);
  if (String(activeKey) !== String(eventKey)) return null;

  return (
    <div role="tabpanel" className={className} {...props}>
      {children}
    </div>
  );
}

export const Tab = Object.assign(() => null, {
  Container: TabContainer,
  Content: TabContent,
  Pane: TabPane,
});
